import React from "react";
import { Stack } from "@fluentui/react";
import DropDown from "../../../../Forms/DropDown";
import ProprietarySpecificFields from "./ProprietarySpecificFields";
import ProprietaryGeneralFields from "./ProprietaryGeneralFields";
import ThirdPartyFields from "./ThirdPartyFields";
import OpenTextQuestionFields from "./OpenTextQuestionFields";
import SubmitButton from "../../../../Forms/SubmitButton";
import Form from "../../../../Forms/Form";
import { useFormikContext } from "formik";

export const actionItemTypes = [
  { key: "Proprietary Specific", text: "On Platform Specific" },
  { key: "Proprietary General", text: "On Platform General" },
  { key: "Third Party", text: "Third Party" },
  { key: "Open Text Question", text: "Open Text Question" },
];

export const ActionTypes = {
  ProprietarySpecific: "Proprietary Specific",
  ProprietaryGeneral: "Proprietary General",
  ThirdParty: "Third Party",
  OpenTextQuestion: "Open Text Question",
};

const BasicInfoFields = ({ submitting, isUpdate }) => {
  const { getFieldProps } = useFormikContext();
  return (
    <Form width={400}>
      <Stack tokens={{ childrenGap: 20 }}>
        <DropDown
          label="Action Item Type"
          placeholder="Select an option"
          options={actionItemTypes}
          name="actionItemType"
          required
        />
        {getFieldProps("actionItemType").value === actionItemTypes[0].key && (
          <ProprietarySpecificFields />
        )}
        {getFieldProps("actionItemType").value === actionItemTypes[1].key && (
          <ProprietaryGeneralFields />
        )}
        {getFieldProps("actionItemType").value === actionItemTypes[2].key && (
          <ThirdPartyFields />
        )}
        {getFieldProps("actionItemType").value === actionItemTypes[3].key && (
          <OpenTextQuestionFields />
        )}
        <SubmitButton
          text={isUpdate ? "Update" : "Create"}
          loading={submitting}
        />
      </Stack>
    </Form>
  );
};

export default BasicInfoFields;
